import React from 'react'
import { useNavigate } from 'react-router-dom'

interface SubmenuItem {
  id: string
  label: string
  href: string
}

interface SubmenuProps {
  items: SubmenuItem[]
  activeItem: string
}

export const Submenu: React.FC<SubmenuProps> = ({ items, activeItem }) => {
  const navigate = useNavigate()

  return (
    <div className="relative">
      <nav className="flex space-x-8">
        {items.map(item => (
          <a
            key={item.id}
            href={item.href}
            onClick={e => {
              e.preventDefault()
              navigate(item.href)
            }}
            className={`relative text-base font-bold tracking-wide transition-colors cursor-pointer ${
              activeItem === item.id
                ? 'text-highlight-pink'
                : 'text-dark-blue hover:text-highlight-blue'
            }`}
          >
            {item.label}
            {activeItem === item.id && (
              <div className="absolute -bottom-1 left-0 right-0 h-[3px] bg-highlight-pink z-10"></div>
            )}
          </a>
        ))}
      </nav>
      <div className="absolute -bottom-1 left-0 right-0 h-[3px] bg-light-pink"></div>
    </div>
  )
}
